import crLogo from '@/assets/CR.png';
import {
  Tooltip,
  TooltipContent,
  TooltipProvider,
  TooltipTrigger
} from '@/components/ui/tooltip';
import { cn } from '@/lib/utils';
import { Translator } from 'components/i18n';

import { Sidebar } from '../icons/Sidebar';
import { useSidebar } from '../ui/sidebar';

/**
 * The CR logo doubles as the sidebar toggle. On desktop it crossfades from the
 * logo to the panel icon on hover; on touch it stays a logo and taps toggle.
 * Rendered both in the header (open control when the sidebar is collapsed) and
 * at the sidebar's edge (close control when expanded); `toggleSidebar` handles
 * the desktop-collapse vs mobile-Sheet distinction.
 */
export default function LogoSidebarToggle({
  className
}: {
  className?: string;
}) {
  const { open, openMobile, isMobile, toggleSidebar } = useSidebar();
  const expanded = isMobile ? openMobile : open;

  return (
    <TooltipProvider>
      <Tooltip>
        <TooltipTrigger asChild>
          <button
            type="button"
            onClick={toggleSidebar}
            aria-label={expanded ? 'Close sidebar' : 'Open sidebar'}
            className={cn(
              'group relative h-8 w-8 shrink-0 rounded-full ring-1 ring-border/60 transition-transform active:scale-95',
              className
            )}
          >
            <img
              src={crLogo}
              alt="Crimson Raven"
              className={cn(
                'h-8 w-8 rounded-full object-cover transition-opacity duration-200',
                !isMobile && 'group-hover:opacity-0'
              )}
            />
            {!isMobile && (
              <span className="absolute inset-0 flex items-center justify-center rounded-full bg-background opacity-0 transition-opacity duration-200 group-hover:opacity-100">
                <Sidebar className="!size-5 text-muted-foreground" />
              </span>
            )}
          </button>
        </TooltipTrigger>
        <TooltipContent>
          <p>
            {expanded ? (
              <Translator path="threadHistory.sidebar.actions.close" />
            ) : (
              <Translator path="threadHistory.sidebar.actions.open" />
            )}
          </p>
        </TooltipContent>
      </Tooltip>
    </TooltipProvider>
  );
}
